export default __webpack_public_path__ + "ba75ada47dd97dfba6ab0c5d21a2c8ab.png";